import React from 'react';

import { URL_API } from '../constants/common.js';
import { ERROR_MESSAGE } from '../../app/common/constants.js';
import { HttpConnection } from './http-connection.js'

import { call, put } from 'redux-saga/effects';

export const getQuery = (query) => {
    let split = query.slice(1).split('&');
    let array = {};
    for(let key in split) {
        let params = split[key].split('=');
        array[params[0]] = params[1];
    }

    return array;
}

export const getRandomText = (length) => {
	if (!length) {
        length = 8;
    }

    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (var i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

export const getSplitedDivs = (str, delimiter) => {
    const s = str.split(delimiter);
    let divs = [];
    for(let key in s) {
        let i = key;
        if (s[key].indexOf("<LINK>")> -1) {
            const link = s[key].slice(s[key].indexOf("<LINK>")+6,s[key].indexOf("</LINK>"));
            let title = link;
            if (link.indexOf("mailto:") > -1) {
                title = link.slice(link.indexOf("mailto:")+7);
            };
            divs.push(
                <div key={i}>
                    {s[key].slice(0,s[key].indexOf("<LINK>"))}
                    <a href={link} target="_blank" rel="noopener noreferrer">{title}</a>
                    {s[key].slice(s[key].indexOf("</LINK>")+7)}
                </div>
            );
        } else {
            divs.push(
                <div key={i}>
                    {s[key] ? s[key] : <br/>}
                </div>
            );   
        }
    }

    return divs;
}

export const checkNull = (value) => {
    if(value === null) return false;
    if(value === undefined) return false;
    return true;
}

export function* loginCheck() {
    let persist = localStorage.getItem("persist:root");
    const token = localStorage.getItem('token');
    let json = JSON.parse(persist);
    let login;
    if(persist !== null && json.login) {
        login = JSON.parse(json.login);
    } else {
        return "-1";
    }
    if(!login.user) {
        return "-1";
    }
    if(!login.user.id || !token) {
        return "-1";
    }

    let http = new HttpConnection();
    let info = {
        url: URL_API + '/loginCheck',
        parameter: {
            id: login.user.id,
            token: token,
        },
    }

    let data = yield call(http.post, info);
    if(data.statusCode === 200){
        yield put({
            type: "UpdateUser",
            user: data.body.user,
        });

        localStorage.setItem('token', data.body.token);
        return data.body.token;
    } else {
        if (data.statusCode === 403) {
            // 端末上限（トークン最大）エラー
            let errmessage = [];
            for (const msg of ERROR_MESSAGE["maximum_login"]) {
                errmessage.push(msg);
                errmessage.push(<br />);
            }
            
            yield put({
                type: "ErrorInfo",
                source: "loginCheck",
                statusCode: data.statusCode,
                error: errmessage,
            });

        } else if (data.statusCode === 405) {
            // 退会済みエラー
            let errmessage = [];
            for (const msg of ERROR_MESSAGE["unsubscribe"]) {
                errmessage.push(msg);
                errmessage.push(<br />);
            }
            yield put({
                type: "ErrorInfo",
                source: "loginCheck",
                statusCode: data.statusCode,
                error: errmessage,
            });
        } else {
            yield put({
                type: "ErrorInfo",
                source: "loginCheck",
                statusCode: data.statusCode,
                error: data.error,
            });
        }

        return "-1";
    }
}

export function* maintenanceCheck() {
    let http = new HttpConnection();

    let info = {
        url: URL_API + '/checkMaintenance',
        parameter: {
        },
    }
    let data = yield call(http.get, info);
    if(data.statusCode === 200){
        localStorage.setItem("Maintenance", false);
        localStorage.setItem("Between", "");
        return 0;
    } else {
        localStorage.setItem("Maintenance", true);
        localStorage.setItem("Between", data.between);
        return 1;
    }
}

export function convISO8601(date) {
    if(!date) return;
    let t = date.split(' ');
    let time;
    if(t[1]) {
        time = t[1].split(':');
        time[2] = '00';
    } else {
        time[0] = '00';
        time[1] = '00';
        time[2] = '00';
    }
    return t[0] + 'T' + time[0] + ':' + time[1] + ':' + time[2] + '+09:00';
}

export function getNextMonth(date) {
	// 基準の年月日を取得
	var year = date.getFullYear();
	var month = date.getMonth();

	// 基準の年月からDateオブジェクトを生成
	var nextDate = new Date(year, month, 1);
	// 月の設定を変更
    nextDate.setMonth(nextDate.getMonth() + 1);

	return nextDate;
}
export function getPrevMonth(date) {
	// 基準の年月日を取得
	var year = date.getFullYear();
	var month = date.getMonth();

	// 基準の年月からDateオブジェクトを生成
	var nextDate = new Date(year, month, 1);
	// 月の設定を変更
    nextDate.setMonth(nextDate.getMonth() - 1);
    
	return nextDate;
}

export function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getMondayDate(date) {
    //指定した日付の週の月曜日を取得
    let mondayDate = new Date();
    let dateNumber = date.getDay();
    let mondayNumber = 1;

    if(dateNumber === 0){
        dateNumber = 7;
    }
    
    mondayDate.setDate(date.getDate() - (dateNumber - mondayNumber));
    // YYYY/MM/DDの形式でreturn
    let returnMondayDate = mondayDate.getFullYear() + "/" + ("0" + (mondayDate.getMonth() + 1)).slice(-2) + "/" + ('0' + mondayDate.getDate()).slice(-2);

    return returnMondayDate;
}

/**
 * カンマ区切り文字列をカンマで分解して配列を返却
 * CSVの""で囲まれた内部のカンマを文字列として扱う（例)"aaaa, bbbb",dddd →　「aaaa, bbbb」「dddd」の2要素の配列を返却
 *
 */
export const csvSplit = (line) => {
    let character = "";
    let sentence = "";
    const data = [];
    let insideQuotes = false;
    for (let i = 0; i < line.length; i++) {
      character = line.charAt(i);
      if (character === "," && !insideQuotes) {
        data.push(sentence);
        sentence = "";
      } else if (character === "," && insideQuotes) {
        sentence = sentence + character;
      } else if (character === '"') {
        // Check for double quotes inside a quoted string
        if (i < line.length - 1 && line.charAt(i + 1) === '"') {
            sentence = sentence + '"';
            i++; // Skip the next double quote
        } else {
            insideQuotes = !insideQuotes;
        }
      } else {
        sentence = sentence + character;
      }
    }
    data.push(sentence);
    return data;
}

// 専用教材受講権限チェック
export const checkAvailableLimitedSubjectSet = () => {
    const availableLimitedSubjectSet = localStorage.getItem('availableLimitedSubjectSet');
    const limitedSubjectSetEndDate = localStorage.getItem('limitedSubjectSetEndDate');

    // 受講専用教材が存在しない場合は、権限無しとする
    if(!availableLimitedSubjectSet) {
        return false;
    }

    // 受講専用教材が存在するかつ配布終了日が設定されている場合、配布終了日が過ぎているか確認
    if(availableLimitedSubjectSet.split(",").length > 0 && limitedSubjectSetEndDate && limitedSubjectSetEndDate !== "-"  ) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const limitedSubjectSetEndDateList = limitedSubjectSetEndDate.split("-");
        const limitedSubjectSetEndDateInstance = new Date(Number(limitedSubjectSetEndDateList[0]), Number(limitedSubjectSetEndDateList[1]) - 1, Number(limitedSubjectSetEndDateList[2]));
        // 配布終了日が過ぎていたら権限無し
        if(currentDate > limitedSubjectSetEndDateInstance) {
            return false;
        }
    }

    return true;

}
